const authActionTypes = {
  SIGNED_IN: 'SIGNED_IN',
};

const INITIAL_AUTH_STATE = {
  isSignedIn: false,
  current: {},
};

export const setAuthenticatedStatus = ({ id, roles }) => ({
  type: authActionTypes.SIGNED_IN,
  payload: {
    id,
    roles,
  },
});

const authenticationReducer = (
  state = INITIAL_AUTH_STATE,
  { type, payload }
) => {
  switch (type) {
    case authActionTypes.SIGNED_IN:
      return {
        ...state,
        isSignedIn: !!payload?.id,
        current: { ...state.current, roles: payload?.roles },
      };
    default:
      return state;
  }
};

export default authenticationReducer;
